import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog11.css';
import blogImage from '../Asets/Blog.jpg';        // hero background
import aiImg from '../Asets/blog1111.png';        // detail image (update the path if needed)
import Header from '../components/header';
import Footer from '../components/footer';

const Blog11 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            How Artificial Intelligence is Transforming Education  Red School House Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 01 October 2025</div>
          <br />

          <img
            src={aiImg}
            alt="How AI is Transforming Education"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              <strong>How AI is Changing the World of Learning</strong>
            </p>
            <p>
              Education is no longer limited to chalkboards and textbooks. In today’s digital age, 
              <strong>Artificial Intelligence (AI) is reshaping the way children learn, teachers teach, and schools operate.</strong> 
              From smart learning apps to personalized study plans, AI is making education more engaging, interactive, and child-friendly.
            </p>
            <p>
              At <strong>Red School House Vadodara</strong>, we believe in nurturing curiosity through play, stories, and real-life experiences—
              <strong>and we also recognize how thoughtful technology use can make learning more exciting and effective.</strong>
            </p>

            <h3>The Role of AI in Education</h3>

            <h3>🎓 1. Personalized Learning</h3>
            <p>
              Every child learns at a different pace. <strong>AI-powered tools adapt to each student’s needs</strong>, 
              offering lessons, games, and exercises suited to their level—making learning less stressful and more enjoyable.
            </p>

            <h3>📊 2. Smarter Assessments</h3>
            <p>
              Instead of only traditional testing, <strong>AI provides instant feedback</strong>. It helps teachers see where a child is excelling 
              and where extra support is needed.
            </p>

            <h3>🎮 3. Interactive Learning Tools</h3>
            <p>
              From story-based learning apps to fun educational games, <strong>AI turns classrooms into interactive playgrounds</strong> 
              where children can explore and learn by doing.
            </p>

            <h3>🌍 4. Breaking Barriers</h3>
            <p>
              <strong>AI platforms connect children to knowledge from around the world.</strong> Even at an early age, kids can listen to stories, 
              watch experiments, and explore topics that spark their imagination.
            </p>

            <h3>👩‍🏫 5. Supporting Teachers</h3>
            <p>
              AI doesn’t replace teachers—it <strong>supports</strong> them. By handling routine tasks like grading or organizing materials, 
              AI gives teachers more time to focus on what truly matters—<strong>teaching with love and care</strong>.
            </p>

            <h3>Why AI + Human Touch Matters</h3>
            <p>
              While AI brings amazing opportunities, the <strong>human connection remains at the heart of education</strong>. 
              A caring teacher, supportive family, and joyful classroom environment cannot be replaced by technology.
            </p>
            <p>
              At <strong>Red School House Vadodara</strong>, we blend the best of both worlds:
            </p>
            <ul>
              <li><strong>Joyful, story-based learning</strong> to spark imagination.</li>
              <li><strong>Hands-on exploration</strong> to build real-world understanding.</li>
              <li><strong>Smart tools</strong> to support curiosity in fun, age-appropriate ways.</li>
            </ul>

            <h3>About Red School House Vadodara</h3>
            <p>
              At <strong>Red School House Vadodara</strong>, every day is a chance to nurture young minds. 
              Recognized as the <strong>Best Nursery School in Vadodara</strong>, we turn learning into a playful journey 
              where children grow with confidence, creativity, and care.
            </p>

            <p>
              <strong>Address:</strong> A-25, Castle White, Opposite Main, Harni Water Tank, Harni Sama Link Road, Vadodara – 390008
              <br />
              <strong>Mobile:</strong> +91 7778851070
              <br />
              <strong>Email:</strong> redschoolhousebaroda2025@gmail.com
              <br />
              <strong>Website:</strong>{' '}
              <a href="https://redhouseschoolvadodara.in/" target="_blank" rel="noreferrer">
                redhouseschoolvadodara.in
              </a>
              <br />
              <strong>Instagram:</strong>{' '}
              <a href="https://www.instagram.com/redschoolhousebaroda" target="_blank" rel="noreferrer">
                @redschoolhousebaroda
              </a>
              <br />
              <strong>Google Business Profile:</strong>{' '}
              <a href="https://www.google.com/search?q=Red+School+House+Vadodara" target="_blank" rel="noreferrer">
                Click Here
              </a>
            </p>

            <h3>Final Thoughts</h3>
            <p>
              <strong>AI is a powerful partner in education, but it shines brightest with a caring human touch.</strong> 
              With the right balance, children learn to think, create, and collaborate—skills that last a lifetime.
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog11;
